<template>
  <div class="el-chunk">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'PhysicalWorld'
}
</script>
